module.exports = __webpack_public_path__ + "static/2-76dccb806fd905881db71ae4e9dbe5fe.jpg";